export default "/_next/static/chunks/fonts/Montserrat-ExtraLightItalic-latin-6914e309c611da8f5ed276968bc2fc3f.woff2";